module.exports = __webpack_public_path__ + "static/img/davis_pictgrid31_980x801.1998537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid31_980x801.jpg
// module id = rWhk
// module chunks = 0